<script>
  import { createComponent } from '@mpxjs/core'
  import { filterHighlightText } from '@/common/public'

  createComponent({
    props: {
      // '普通文本{{高亮文本}}普通文本\n换行后的普通文本'
      text: {
        type: String,
        value: ''
      },
      color: {
        type: String,
        value: '#333'
      },
      hlColor: {
        type: String,
        value: '#FF5900'
      },
      hlStyle: {
        type: Object,
        value: {}
      },
      commonStyle: {
        type: Object,
        value: {}
      }
    },
    computed: {
      texts() {
        return filterHighlightText(this.text)
      },
      highlightStyle() {
        return {
          ...this.hlStyle,
          color: this.hlColor
        }
      },
      computedCommonStyle() {
        return {
          color: this.color,
          ...this.commonStyle,
        }
      }
    },
  })
</script>

<template>
  <text class="vam">
    <text
      class="vam"
      wx:for="{{texts}}"
      wx:key="index"
      wx:style="{{ item.highlight ? highlightStyle : computedCommonStyle }}"
      >{{ item.value }}</text
    >
    <slot />
  </text>
</template>

<style lang="stylus" scoped>
  .vam
    vertical-align middle
</style>

<script name="json">
  module.exports = {
    component: true
  }
</script>
